import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const useSearchParams = <T = any>() => {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const urlSearchParam = useMemo(() => new URLSearchParams(search), [search]);
  const set = (
    name: keyof T,
    value: string,
    pushImmediately: boolean = true
  ) => {
    urlSearchParam.set(name as string, value);
    pushImmediately &&
      history.push({ pathname: pathname, search: urlSearchParam.toString() });
  };
  const setValues = (values: Partial<Record<keyof T, string>>) => {
    Object.keys(values).forEach((e) =>
      set(e as keyof T, values[e as keyof T]!, false)
    );
    history.push({ pathname: pathname, search: urlSearchParam.toString() });
  };
  const get = (name: keyof T) => urlSearchParam.get(name as string);
  return { set, setValues, get };
};
